import React, { useState, useEffect } from 'react';
import MapsBar from '../../container/MapsBar/MapsBar';
import HandyCard from '../../container/HandyCard/HandyCard'
import axios from 'axios';
import {APIURL,BINGAPIKEY} from '../../config'
import { AnalyticsBrowser } from '@segment/analytics-next'
import { SEGMENTAPIKEY } from '../../config';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from "@mui/material/TextField";
import moment from "moment";
import Button from '@mui/material/Button';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { display, height } from '@mui/system';


const analytics = AnalyticsBrowser.load({ writeKey: SEGMENTAPIKEY })

  
const EmpLocate = (props) => {
    const [empLocData, setEmpLocData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [loggedToSegment, setLoggedToSegment] = useState(false);
    const [checkoutDetails, setCheckoutDetails] = useState({
        checkoutTime: moment().format('YYYY-MM-DDTHH:mm'), 
        reason: '', 
        verification: '', 
        updated_by: props.user.emp_id
    });
    const [showCheckoutDialog, setShowCheckoutDialog] = useState(false);
    const [showMap, setShowMap] = useState(false);

    const submitCheckOut = async(checkoutDetailsParam) => {
        if(moment(checkoutDetailsParam.cardData.empLocdate).isAfter(moment(checkoutDetailsParam.checkoutTime))) {
            alert('Checkout time cannot be before checkin time');
            return;
        }
        let data = { 
            projId: checkoutDetailsParam.cardData.tas_pro_id,
            empName: checkoutDetailsParam.cardData.emp_first_name + '' + checkoutDetailsParam.cardData.emp_last_name,
            empId: checkoutDetailsParam.cardData.tas_emp_id,
            taskTitle: checkoutDetailsParam.cardData.tas_title,
            companyId: props.user.comp_id,
            taskId: checkoutDetailsParam.cardData.tas_id,
            date: moment(checkoutDetailsParam.checkoutTime).format('YYYY-MM-DDTHH:mm:ss'),
            updated_by: props.user.emp_id,
            reason: checkoutDetailsParam.reason,
            verification: checkoutDetailsParam.verification
        }
        try {
            await axios.put(APIURL + '/locate/locatePage', { ...data });
            await axios.put(APIURL + '/task/checkin', {tas_id: checkoutDetailsParam.cardData.tas_id, checkin: false})
            toggleShowCheckOutDialog()
        } catch (error) {
            if (error.response && error.response.status === 409) {
                const conflictData = error.response.data;
                let message = 'Update failed: A conflicting time entry already exists for this project.';
                
                if (conflictData.overlappingTask) {
                    const task = conflictData.overlappingTask;
                    message += `\n\nTask Title: ${task.taskTitle || 'N/A'}\n`;
                    message += `Check-In: ${task.checkIn ? moment(task.checkIn).format('h:mm A [on] MMMM Do') : 'N/A'}\n`;
                    message += `Check-Out: ${task.checkOut ? moment(task.checkOut).format('h:mm A [on] MMMM Do') : 'N/A'}`;
                }
                
                message += '\n\nPlease verify the checkout time and try again.';
                alert(message);
                return;
            }
            // Re-throw other errors
            throw error;
        }
    }

    const toggleShowCheckOutDialog = (cardData) => {
        setShowCheckoutDialog(!showCheckoutDialog);
        if (cardData) {
            setCheckoutDetails({...checkoutDetails, cardData: cardData});
        }
    }

    const logToSegment = async () => {
        if(loggedToSegment) {
          return;
        }
        let page = String(window.location.href).split("/").pop()
        if(page.includes("fieldworker") || page === "" || page === "#") {
            page = "Home";
        } else {
            page = String(page).charAt(0).toUpperCase() + String(page).toLowerCase().slice(1);
        }
        console.log(page, props.user.emp_id)
        analytics.page(page, {
            title:page,
            path:page,
        }, {
            userId:String(props.user.emp_id),
        })
        console.log("logged to segment successfully")
        setLoggedToSegment(true);
    }


    useEffect(() => {
        const fetchData = async () => {
            props.checkTokenExpiry();
            logToSegment();
            axios.defaults.headers = {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                "Access-Control-Allow-Headers": 'Origin, X-Requested-With, Content-Type, Accept, Authorization',
                "Access-Control-Allow-Methods": "PUT, GET, POST, DELETE, OPTIONS",
                "ACCESS-CONTROL-ALLOW-CREDENTIAL": true,
                Authorization: 'Bearer ' + window.localStorage.getItem('Fw4_access_Token')
            };
            try {
                let empLoc = await axios.get(APIURL + "/locate/empLoc", { params: { comp_id: props.comp_id } });
                console.log(empLoc)
                setEmpLocData(Array.isArray(empLoc.data) ? empLoc.data : []);
                setIsLoading(false);
            } catch (error) {
                console.error(error);
                setEmpLocData([]);
                setIsLoading(false);
            }
        };
        
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const getMapsDataFormat = () => {
        let mapsData = empLocData.filter((ele) => ele.emploc_lat && ele.emploc_lon).map((pushPinData)=>{
            return {
                "location":[pushPinData.emploc_lat, pushPinData.emploc_lon], 
                "addHandler":"mouseover",
                "infoboxOption": { title: pushPinData.tas_title, description: pushPinData.empAddress},
                "pushPinOption":{ color: 'red',title: pushPinData.emp_first_name + pushPinData.emp_last_name}
            }
        })

        return mapsData
    }
    
    let empLocateCards = empLocData.map((data)=> {
        if(data.tas_is_active === 0 || data.tas_is_active === 1){
            return <HandyCard key={data.empLocId} employeelocate data={data} user={props.user} toggleShowCheckOutDialog={toggleShowCheckOutDialog}/>
        }
        return null;
    })
    
    return (
        <div style={{ height: 'calc(100vh - 100px)', display: 'flex', flexDirection: 'column', width: '100%' }}>
            {!isLoading && <MapsBar
                mapsData={getMapsDataFormat()}
                toggleMap={(showMap) => { setShowMap(showMap) }}
                user={props.user}
            />}
            <hr/>
            {!isLoading &&
                <h4>Last Known Activity:</h4>
            }
            <div className="overflow-auto" style={{height:"auto",scrollbarColor:"#3FA7D6", overflowY: "scroll" }}>
            {!!isLoading && 
            (<div className="d-flex flex-row w-100 justify-content-center mt-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>)}
            {!isLoading && empLocateCards}
            {!isLoading && empLocData.length === 0 && 
                <div style={{marginTop: 100}} className='d-flex flex-row w-100 justify-content-center align-items-center'>
                    <div>
                        <img src='./Locationsgraphics.png' alt='Locationsgraphics' style={{width: '10rem', height: '10rem', margin: 10}}/>
                    </div>    
                    <div className='d-flex flex-column justify-content-center align-items-center'>
                        <h5 style={{fontFamily: 'Lato',marginTop: 48,  marginBottom: 30}} className='text-center'>Your team haven't made any client visits yet </h5>
                        <p style={{fontSize: 14, width: '70%',fontFamily: 'Lato'}} className='text-muted text-center text-wrap'>Once they have, you'll see an overview all all visits here. Still need to invite your team? Let's add them to FieldWorker now!</p>
                    </div>    
                </div>
            }
            </div>
            <Dialog open={showCheckoutDialog} onClose={() => {}} className='locatePageCheckoutDialog'>
                <DialogTitle>Confirm Manual Checkout Details</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please fill out the following information to complete the manual checkout.
                    </DialogContentText>
                    <hr></hr>
                    <TextField
                        id="checkoutTime"
                        label="Check-Out Time"
                        type="datetime-local"
                        value={checkoutDetails.checkoutTime}
                        onChange={(d) => {
                            setCheckoutDetails({...checkoutDetails, checkoutTime: moment(d.target.value.replace(/Z/g, "")).format('YYYY-MM-DDTHH:mm')})
                        }}
                        // className={classes.textField}
                        style={{ width: '50%', marginBottom: '0px' }}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                    <TextField
                        margin="dense"
                        id="reason"
                        label="Reason for Admin checkout"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={checkoutDetails.reason}
                        onChange={(d) => {
                            setCheckoutDetails({...checkoutDetails, reason: d.target.value})
                        }}
                    />
                    <TextField
                        margin="dense"
                        id="verification"
                        label="How was the task verified?"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={checkoutDetails.verification}
                        onChange={(d) => {
                            setCheckoutDetails({...checkoutDetails, verification: d.target.value})
                        }}
                    />
                </DialogContent>
                <DialogActions>
                <Button onClick={toggleShowCheckOutDialog}>Cancel</Button>
                <Button onClick={() => submitCheckOut(checkoutDetails)}>Submit</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
export default EmpLocate
